import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { getDepartureDate } from 'Components/widgets/alternative-proposals/AlternativeProposalsUtils';
import { t } from 'Src/i18n';
import { API_DATE_FORMAT } from 'Utils/date/apiDate';
import { formatDate } from 'Utils/date/dateUtils';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { Icon } from 'Components/frameworks/icon/Icon';
import { AttendeesSummary } from 'Components/widgets/package/price/AttendeesSummary';
import { DateSummary } from 'Components/widgets/package/price/DateSummary';
import { TransportSummary } from 'Components/widgets/package/price/TransportSummary';
type Props = {
  adultsNumber: number;
  arrivalDate: string;
  className?: string;
  departureCity: string;
  duration: number;
  kidsNumber: number;
};
export const AlternativeResortCriteria = ({
  adultsNumber,
  arrivalDate,
  className,
  departureCity,
  duration,
  kidsNumber,
}: Props) => {
  const getFormattedDate = formatDate('D MMMM YYYY');
  const departureDate = getDepartureDate({
    date: arrivalDate,
    duration,
    format: API_DATE_FORMAT,
    unit: 'days',
  });
  return (
    <Capsule
      className={className}
      contentClassName="flex flex-col gap-10 p-20"
      dataTestId="AlternativeResortCriteria"
    >
      <DateSummary
        template={t('booking.counterProposalPopIn.fromTo')}
        values={{
          arrivalDate: getFormattedDate(arrivalDate, 'YYYYMMDD') || '',
          departureDate: getFormattedDate(departureDate, 'YYYYMMDD') || '',
        }}
      />
      <AttendeesSummary adults={adultsNumber} kids={kidsNumber} />
      <TransportSummary
        departure={departureCity !== 'NO' ? departureCity : null}
        transportIcon={ICONS.TRANSPORT}
      />
      <p className="flex items-start gap-5 text-12 font-bold text-orange">
        <Icon className="shrink-0 translate-y-[0.2em]" name={ICONS.WARNING} width="1em" />
        {t('booking.counterProposalPopIn.resortCounterProposalTransportReassurance')}
      </p>
    </Capsule>
  );
};
